export const achievements = [
  {
    id: 1,
    title: "Brand Model Magazine",
    date: "2024-12-09",
    description: "Issue 1173: Brand Model Magazine, showcasing innovative children's fashion photography.",
    imageUrl: "/images/achievements/brand model magazine issue 1173.jpg",
    link: "http://www.brandmodelmagazine.com/",
    type: "magazine"
  },
  {
    id: 2,
    title: "Brand Model Magazine Back Cover",
    date: "2024-12-12",
    description: "Issue 1175: Brand Model Magazine back cover.",
    imageUrl: "/images/achievements/back cover issue 1175 brand model magazine.jpg",
    link: "http://www.brandmodelmagazine.com/",
    type: "magazine"
  },
  {
    id: 3,
    title: "Bran Model Magazine Front Cover",
    date: "2023-11-30",
    description: "Issue 1061: Brand Model Magazine front cover.",
    imageUrl: "/images/achievements/brand model magazine COVER 11_30_23 issue 1061.jpg",
    link: "https://www.magcloud.com/browse/issue/2671447",
    type: "magazine"
  }
];

export const achievementTypes = [
  { id: "all", name: "All Achievements" },
  { id: "magazine", name: "Magazine Features" },
  { id: "award", name: "Awards" },
  { id: "exhibition", name: "Exhibitions" }
];
